<template>
    <v-progress-circular size="20" indeterminate color="primary" width="2" v-if="!division"></v-progress-circular>
    <v-card class="ma-3 pa-2 d-flex flex-column justify-center border" outlined v-else-if="division.single_match && match && !compact" @click="$emit('click')">
        <div v-if="showTime && matchTime" class="match-time">{{ matchTime }}</div>
        <div class="d-flex flex-row align-center my-1">
            <v-avatar size="30" class="mr-2">
                <img :src="'/api/public/image/get?type=team&size=30x30&id=' + homeTeam.team_id" v-if="homeTeam.team_id" />
            </v-avatar>
            <div class="team-name">{{homeTeam.name}}</div>
            <div class="ml-auto">{{ homeResult }}</div>
        </div>
        <div class="d-flex flex-row align-center my-1">
            <v-avatar size="30" class="mr-2">
                <img :src="'/api/public/image/get?type=team&size=30x30&id=' + awayTeam.team_id" v-if="awayTeam.team_id" />
            </v-avatar>
            <div class="team-name">{{awayTeam.name}}</div>
            <div class="ml-auto">{{ awayResult }}</div>
        </div>
    </v-card>
    <v-card v-else-if="division.single_match && match && compact" class="ma-3 pa-1 fill-height border" outlined @click="$emit('click')">
        <div class="d-flex flex-row justify-space-between">
            <div class="team-name">{{homeTeam.name}}</div>
            <div class="team-name text-right">{{awayTeam.name}}</div>
        </div>
    </v-card>
    <v-card v-else class="ma-3 pa-2 fill-height border" outlined @click="$emit('click')">
        <v-card-title class="text-h6">{{ division.name }}</v-card-title>
    </v-card>
</template>

<script>
export default {
    name: 'zoezi-teamsport-playoff-tree-division-card',
    props: {
        division: {
            type: Object
        },
        compact: {
            type: Boolean,
            default: false
        },
        showTime: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        match() {
            return this.division.matches[0]
        },
        matchTime() {
            if (this.match.startTime) {
                return Date.formatFullShorter(this.match.startTime) + ' ' + Date.newFull(this.match.startTime).hhmm()
            }

            return null;
        },
        homeTeam() {
            return this.match.competitors[0]
        },
        awayTeam() {
            return this.match.competitors[1]
        },
        homeResult() {
            return this.match.result?.find(r => r.team_id == this.match.competitors[0].team_id)?.result;
        },
        awayResult() {
            return this.match.result?.find(r => r.team_id == this.match.competitors[1].team_id)?.result;
        },
    }
}
</script>

<style scoped>
.border {
    border: 1px solid var(--z-primary);
}
.team-name {
    max-width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.match-time {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    padding: 4px 8px;
    border: 1px solid var(--z-primary);
    border-radius: 4px;
    white-space: nowrap;
}
</style>
